module.exports = __webpack_public_path__ + "853ec4f8ac2e56095ab5cf45ca862b8b.svg";